import heteroevaluations from './heteroevaluation.json';
import integrals from './integrals.json';

export const reportsTranslations = {
  ...heteroevaluations,
  ...integrals,
};
